<ng-container *transloco="let t">
  <img routerLink="/" [alt]="t('NAVIGATION.COMPANY_LOGO')" [src]="logo()" />

  <span class="divider"></span>

  <ng-container *ngTemplateOutlet="titleTemplate()" />

  <section class="actions">
    @for (template of actionsTemplates(); track template; let last = $last) {
      <ng-container *ngTemplateOutlet="template" />
      @if (!last) { <span class="divider"></span> }
    }
  </section>

  <chr-button-icon class="nav-button"
                   icon="hamburger"
                   palette="neutral"
                   variant="invisible"
                   [attr.aria-label]="t('NAVIGATION.ARIA.BUTTONS.HAMBURGER')"
                   (chr-action)="showAppNavigation()" />
</ng-container>

